export default "__VITE_ASSET__BKD47XfB__"